export default __webpack_public_path__ + "static/media/feb4.42398053.jpg";